(function Module() {
	'use strict';
	mySynch.controller('BodyScoringV1_3Controller', [
		'$scope',
		'$interval',
		'ApiFactory',
		'F360Service',
		'F360Constant',
		'$window',
		'AuditService',
		'$location',
		'CookieFactory',
		'MySynchFactory',
		'clientLoggerService',
		function BodyScoringV1_3Controller($s,$interval,api, f360Service, f360Constant, $window, auditService, $location,cookies,MSF, log) {
			console.log("@@@@@@@@@ V1.3 Body Score @@@@@@@@");
			
			var self = this;
			$s.breadcrumbs = f360Service.getReport360Breadcrumbs();
			$s.lastBreadcrumbs = $s.breadcrumbs.pop();
			$s.heading = $s.lastBreadcrumbs.heading;

			$s.auditId = auditService.getAuditId($location.url());

			$s.auditApiVersion;
			$s.auditAnswers = [];

			$s.avgQuestion = {};
			$s.avgAnswer = {};

			$s.numberCows = 0;
			$s.scores = [];
			$s.avgScore = 0;
			$s.maxScore = 0;
			$s.minScore = 0;
			$s.stepScore = 0.25;

			$s.currentIndex = 0;
			$s.currentScore = 0;
			$s.allowComplete = false;
			$s.scoreLoaded = false;
			$s.maxAllowedScore = 5;

			$s.showPrevious = false;
			$s.showNext = true;
			$s.allowLeaveThisPage = false;
			
			$s.sliderWidth = 300;

			$s.mySynchState = {};
			$s.activeFarm = {};
			$s.currentHerd = {};

			
			$s.codeFile = [];


			// flag for that is set true when and update answers call occurs successfuly without updating the server
			$s.syncInProgress = false;
			$s.isDirty = false;
			$s.updateInProgress = false;

			$s.checkSyncStatusTimer = undefined;
		   
			// watcher degresigration variables
			var deregOnFarmChange = undefined;

			function loadCurrentHerd(){
				   
				auditService.getHerdsByFarmId(_.get($s.activeFarm,'farmId'), function getF360HerdsByFarmId(err, herd){
					  if (err) {
						  console.log('err', err);
					  }else{
						$s.currentHerd =  herd[0];
						var currentHMS = _.get($s.currentHerd,'herdMgmtSoftware');
								   //if the farm doesn't currently have the F360  module on we will want to redirect the user that got here
					
						  if(_.isNull(currentHMS) || _.isUndefined(currentHMS)){
							 MSF.loadPage('Login');
						  }
			  
					  }       
				});

			 
		  }

			function checkPermissions(){
				
				// we need to check to see if the user who is viewing this screen is the person who create the audit
				// otherwise we need to redirect them to the top level f360 report
				auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
					var auditHerd = _.find(data,{AuditId: $s.auditId},'Name');
					 
					if(!_.isEqual(_.get(auditHerd,'PersonId'),_.get(cookies.user,'PersonId'))){
						MSF.loadPage('Fertility360report');
					}

				});
			}
			
			function getLocalStorageKey(subKey) {
				return $s.auditId + '_' + auditService.getSubHeading($s.heading) + $s.avgQuestion.QuestionId + subKey;
			}
        $s.loadReportData =  function loadReportData(){
			auditService.getIndexedDBAnswerList($s.auditId, function getIndexedDBAnswerList(err, data) {
				if (err) {
					console.log('error getting F360 Answer List: ' + err);
					MSF.confirmation.danger(err,false);
				} 
				if (data && data.length) {
					try{
					 $s.auditAnswers = JSON.parse(data);
					}catch(e){
					  log.error("failed to parse answer list json : "+_.get(e,'message'," "));
					}
				 
				 
				 } else {
					$s.auditAnswers = [];
				 }
				auditService.getIndexedDBQuestionList($s.auditId, function getIndexedDBQuestionList(err, data) {
					if (err) {
						console.log('error getting F360 Question List: ' + err);
						MSF.confirmation.danger(err,false);
					}
					if (data && data.length) {
						var parseDataQuestion = JSON.parse(data);
						var questionDetailsJson = parseDataQuestion.QuestionsJson;

						for (let i = 0; i < questionDetailsJson.length; i++) {
							var question = questionDetailsJson[i].QuestionJson[0];							
							var questionSubHeading = auditService.getSubHeading(question.SubHeading);
							if (questionSubHeading == auditService.getSubHeading($s.heading)) {
								if (auditService.checkQuestionNumberCowsInPen(question)) {
									var answerData = $s.loadAnswerData(question.QuestionId);
									if (answerData.Value > 0) {
										$s.numberCows = Math.ceil((parseInt(answerData.Value)*10)/100);
									}
								} else if (auditService.checkAverageQuesitonBCS(question)) {
									$s.avgQuestion = question;
									$s.avgAnswer = $s.loadAnswerData(question.QuestionId);
									$s.questionAvgScore = question.QuestionId;
								}
							}
						}
						var scoresString = localStorage.getItem(getLocalStorageKey('_bcs_'));
						if (scoresString !== null) {
							$s.scores = scoresString.split(",");
							if ($s.scores.length > $s.numberCows) {
								$s.scores = [];
							} else {
								$s.currentScore = $s.scores[0];
							}
						}
						$s.calculateScore();
						$s.allowComplete = $s.scores.length == $s.numberCows;
						$s.scoreLoaded = true;
					//	if (!window.navigator.onLine) {
							$s.$apply();
						//}
					}
				});
			});
		};
			$s.loadAnswerData = function(quesionId) {
				for (let i = 0; i < $s.auditAnswers.length; i++) {
					if (quesionId == $s.auditAnswers[i].QuestionId) {
						return $s.auditAnswers[i].AnswerDetailsJson;
					}
				}
				return undefined;
			};

			$s.stayOnPage = function stayOnPage() {
				var modalDelete = document.getElementById("popupModal");
				modalDelete.style.display = "none";
			};

			$s.leaveThisPage = function leaveThisPage() {
				$s.allowLeaveThisPage = true;
				window.location.href = $s.nextPage;
			};

			$s.$on('$locationChangeStart', confirmLeavePage);

			function confirmLeavePage(event, next, current) {
				if (next.includes($s.breadcrumbs[2].url)) {
					var sectionKey = `{"subHeading": "${$s.heading}", "questionId": "${$s.questionAvgScore}"}`;
					localStorage.setItem(f360Constant.keySectionScroll, sectionKey);
				} else {
					localStorage.removeItem(f360Constant.keySectionScroll);
				}
				if (!$s.allowComplete && !$s.allowLeaveThisPage) {
					event.preventDefault();
					$s.nextPage = next;
					var modalDelete = document.getElementById("popupModal");
					modalDelete.style.display = "block";
				}
			}
			
			$s.scoreComplete = function scoreComplete(link) {
				$s.updateInProgress = true;
				log.info("BSC scoreComplete start");
				localStorage.setItem(getLocalStorageKey('_bcs_'), $s.scores);
				var notes = null;
				if (typeof $s.avgAnswer !== 'undefined' && typeof $s.avgAnswer.Notes !== 'undefined') {
					notes = $s.avgAnswer.Notes;
				}
				var detailValidation = $s.avgQuestion.QuestionDetailsJson.industryGuideline;

				var metGuidelines = true;
					
				if (detailValidation && detailValidation.validationTemplates) {
					metGuidelines =	$s.validateTemplate(detailValidation.validationTemplates, Number($s.avgScore), $s.avgQuestion);
				} else if (detailValidation && detailValidation.compare) {
					metGuidelines = $s.validateCompare(detailValidation.compare, Number($s.avgScore), $s.avgQuestion);
				}

				var obAnswer = "";

				try{
					var answerTemplateDetailsJsonArray = JSON.parse(_.get(_.find($s.codeFile,{codeType: "JSONTEMPLATES",code:"TMPLF360ANSWER"}),'detailsJson'));
                    var  maxAnswerTemplateApiVer = _.max(
														_.map(answerTemplateDetailsJsonArray,function(answerTmplDetailsVersion){
															var apiVerNumStr = _.get(answerTmplDetailsVersion,'apiVersion').replace("v","");
															return parseFloat(apiVerNumStr);
														})
				                                    );
					obAnswer =  _.get(_.find(answerTemplateDetailsJsonArray,{apiVersion:`v${maxAnswerTemplateApiVer}`}),'template');
				            
	
				   // set original default values that differ than how its defined in sql , but  might not actually need to be these values
				   _.set(obAnswer,'QuestionId',$s.avgQuestion.QuestionId);  
				   _.set(obAnswer,'AnswerDetailsJson.Answered',true);
				   _.set(obAnswer,'AnswerDetailsJson.Value',$s.avgScore);
				   _.set(obAnswer,'AnswerDetailsJson.MetGuideline',metGuidelines);
				   _.set(obAnswer,'AnswerDetailsJson.NoGuideInvolved',true);
				   _.set(obAnswer,'AnswerDetailsJson.Notes',notes);
				   _.set(obAnswer,'AnswerDetailsJson.FormattedRecommends',undefined);
				   _.set(obAnswer,'AnswerDetailsJson.TargetDate',null);
				   _.set(obAnswer,'AnswerDetailsJson.Status',null);
	
	
				}catch(e){
				   log.info("Section Page: Answer Template failed to be acquired from Code File or failed to be parsed");
				}
	
				var foundIndex =  $s.auditAnswers.findIndex(item => item.QuestionId == $s.avgQuestion.QuestionId);
				if (foundIndex > -1 && $s.auditAnswers.length > 0) {
					$s.auditAnswers.splice(foundIndex, 1);
				}
				$s.auditAnswers.push(obAnswer);
				
				// save data
				var AnswerDetailsJson = JSON.stringify($s.auditAnswers);

				$s.isDirty = true;
				auditService.updateAnswer($s.auditId, AnswerDetailsJson, function getF360Update (err, data) {
					if (err) {
						log.error('error getting F360 online check: ' + err);
						$s.isDirty = false;
						$s.updateInProgress = false;
			        	log.info("BSC scoreComplete: error in updating answer, end update");
					}else{

						// if the update was successfull and we are online we can then the data was synced and we can set isDirty false
						if(window.navigator.onLine){

						//	$interval.cancel($s.checkSyncStatusTimer);
							//$s.checkSyncStatusTimer = $interval(function() {
						//		log.info("Body Score: Answer Timer");
						//		checkF360SyncStatus();
						//	}, f360Constant.checkF360SyncInterval);
							
							$s.isDirty = false;
							auditService.updateIsDirty($s.auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
								if (err) {
									log.error('error updateing isDirty flag: ' + err);
								}
						        
								auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
								var auditlistItem = _.find(data,{AuditId: $s.auditId});

						    // 	log.info("BSC scoreComplete: updating last synced date with : ");
							//	log.info(auditlistItem);

								 //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
								if(!_.isUndefined(auditlistItem)){ 
									auditService.updateLastSyncedDate($s.auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
										if (err) {
											log.error('error updating server with device data: ' + err);
										}
										$s.updateInProgress = false;
				
										log.info("BSC scoreComplete: udpated audit sync date after answer update, update end");
										$window.location.href = link;
									});	 
								}else{
									log.info("could not find audit indexedDB failed to update BSC , update end");
									$s.updateInProgress = false;
									
								}

							});
						  });
						}else{
							auditService.updateIsDirty($s.auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
								if (err) {
									log.error('error updateing isDirty flag: ' + err);
								}
								$s.updateInProgress = false;
				                log.info("BSC scoreComplete offline , but updated IsDirty Flag , update end");
								$window.location.href = link;
							});
						}

					
				     	
					}
				});
				
			};

			window.scrollTo(0, 0);
			$s.disabledBtn = true;
			
			$s.calculateScore = function() {
				if ($s.scores.length > 0) {
					var sumValue = 0;
					for (let i = 0; i < $s.scores.length; i++) {
						$s.scores[i] = Number($s.scores[i]);
						sumValue += Number($s.scores[i]);
					}
					
					$s.avgScore = (sumValue/$s.scores.length).toFixed(2);
					$s.minScore = Math.min(...$s.scores);
					$s.maxScore = Math.max(...$s.scores);
				}
			};
			
			$s.next = function next() {
				if ($s.currentIndex < $s.numberCows - 1) {
					if (typeof $s.scores[$s.currentIndex] !== 'number' || $s.scores[$s.currentIndex] <= 0) {
						return true;
					}
					
					$s.showPrevious = true;
					$s.currentIndex += 1;
					if ($s.currentIndex + 1 ==  $s.numberCows) {
						$s.showNext = false;
					}
					var nextScore = 0;
					if (typeof $s.scores[$s.currentIndex] === 'number') {
						nextScore = $s.scores[$s.currentIndex];
					}
					$s.showCowScore(nextScore);
				}
			};

			$s.previous = function previous() {
				if ($s.currentIndex > 0) {
					$s.currentIndex--;
					if ($s.currentIndex == 0) {
						$s.showPrevious = false;
					}
					$s.showNext = true;
					var score = 0;
					if (typeof $s.scores[$s.currentIndex] === 'number') {
						score = $s.scores[$s.currentIndex];
					}
					$s.showCowScore(score);
				}
			};

			$s.showCowScore = function(score) {
				var slider = document.getElementById('myinput');
				var positionPercentage = score/$s.maxAllowedScore * 100;
				slider.value = positionPercentage;
				document.getElementById("myinput").style.background = 'linear-gradient(to right, #0C547E 0%, #0C547E ' + positionPercentage + '%, #96b6d6 ' + positionPercentage + '%, #96b6d6 100%)';
				getlocationSliderText(score);
			};

			function getlocationSliderText(score) {
				var locationText = score/$s.maxAllowedScore * $s.sliderWidth;
				if (locationText == 0) {
					locationText = f360Constant.locationMinium;
				} else if (locationText > 120 && locationText < 290) {
					locationText = locationText - f360Constant.numberMedML;
				}
				else if (locationText > 290) {
					locationText = locationText - f360Constant.numberMaxML;
				}

				var valueText = document.getElementById("valueCount");
				valueText.innerHTML = score;
				valueText.style.marginLeft = locationText + 'px';
			}
			$s.scoreCow = function(score) {
				if (score > 0) {
					$s.scores[$s.currentIndex] = score;
					$s.allowComplete = $s.scores.length == $s.numberCows;
				} else {
					$s.allowComplete = false;
				}
				$s.calculateScore();
				
				if (!$s.$$phase) {
					$s.$digest();
				}
			};
			// TODO: move this function into a service or some kind of global place
			$s.validateTemplate = function validateTemplate(valTpl, value, questionDetails) {
				var validationResult = true;
				if (valTpl !== undefined)
				{
					var detailValidationTpl = valTpl[0];
					
					if (detailValidationTpl.MINVALUE !== undefined) {
						validationResult = value >= detailValidationTpl.MINVALUE;
					}

					if (validationResult && detailValidationTpl.MAXVALUE !== undefined) {
						validationResult = value <= detailValidationTpl.MAXVALUE;
					}
						
					if (validationResult && detailValidationTpl.WITHINRANGE !== undefined) {
						validationResult = value >= detailValidationTpl.WITHINRANGE.loValue && value <= detailValidationTpl.WITHINRANGE.hiValue;
					}

					if (validationResult && detailValidationTpl.NOTWITHINRANGE !== undefined) {
						validationResult = value < detailValidationTpl.WITHINRANGE.loValue && value > detailValidationTpl.WITHINRANGE.hiValue;
					}
					
					if (validationResult && detailValidationTpl.WITHINLIST !== undefined) {
						validationResult = value in detailValidationTpl.WITHINLIST;
					}
					
					if (detailValidationTpl.NOTWITHINLIST !== undefined) {
						validationResult = !(value in detailValidationTpl.NOTWITHINLIST);
					}	
					
				}
			
				return validationResult;
			};
			// TODO: move this function into a service or some kind of global place
			$s.validateCompare = function validateCompare(valCop, value, questionDetails) {
				var validationResult = true;
				if (valCop !== undefined) {
					var detailCompare = valCop;
					var number1 = detailCompare.numValue1;
					var number2 = detailCompare.numValue2;
					if (detailCompare.operation) {
						switch (detailCompare.operation) {
							case "NE":
								validationResult = value !== number1;
								break;
							case "GT":
								validationResult = value > number1;
								break;
							case "GE":
								validationResult = value >= number1;
								break;
							case "LE":
								validationResult = value <= number1;
								break;
							case "LT":
								validationResult = value < number1;
								break;
							case "EQ":
								validationResult = value === number1;
								break;
							case "BE":
								validationResult = (value >= number1 && value <= number2);
								break;
							case "IN":
								validationResult = (value in number1);
								break;
							case "NI":
								validationResult = !(value in number1);
								break;
							default:
								break;
						}
					}
				}
				
				return validationResult;
			};
			document.getElementById("myinput").oninput = function() {
				var score = this.value * $s.maxAllowedScore / 100;
				$s.scoreCow(score);
				var positionPercentage = this.value;
				this.style.background = 'linear-gradient(to right, #0C547E 0%, #0C547E ' + positionPercentage + '%, #96b6d6 ' + positionPercentage + '%, #96b6d6 100%)';
				getlocationSliderText(score); 
			};

	///		 $s.checkSyncStatusTimer = $interval(function() {
	//			log.info("Body Score: Page Timer");
///				checkF360SyncStatus();
//			}, f360Constant.checkF360SyncInterval);

			function checkF360SyncStatus() {
				if (window.navigator.onLine && $s.syncInProgress === false && $s.updateInProgress === false) {


					$s.syncInProgress = true;
					log.info(" Body Score : checkSync: Synch in Progress");

					auditService.getIndexDBListByHerdId(function getF360List(err, data){
						
						if(err){
							log.error("There was err in getting cached list : "+err);
						}

						var activeAuditListData = _.find(data,{AuditId: $s.auditId});
						var lastSyncedDate = _.get(activeAuditListData,'SyncedOn',null);
						if(_.isEqual(lastSyncedDate,"")){
							lastSyncedDate = null;
						}
							
				       var  isDeviceDirty = _.get(activeAuditListData,'IsDeviceDirty',false);

					  // log.info("check Sync: calling getSyncStatus with lastSyncedDate: "+lastSyncedDate+" and isDeviceDirty: "+isDeviceDirty);
					   api.getSyncStatus($s.auditId,lastSyncedDate,isDeviceDirty, function getF360SyncStatus(err, data) {
								if (err) {
									self.isSync = false;
									log.error('error getting F360 online check: ' + err);
								}
								
								if (data) {
									self.isSync = true;
								
									var syncData = data[0];	

									if(!_.isUndefined(syncData)){
										//	 _.set(data,'updateDevice',true);	
									//	log.info("checkedSync: synce data returned with");
										//log.info(syncData);
										if((_.isEqual(_.get(syncData,'ToUpdateServer'),true)) || (_.isEqual(_.get(syncData,'ToUpdateServer').toLowerCase(),"true"))){

											//log.info("checkedSync: server needed updating");
											auditService.updateServerAuditData($s.auditId,function(err,data){
												if (err) {
													log.error('error updating server with device data: ' + err);
													$s.isDirty = true;
												}else{
													$s.isDirty = false;
												}
											///	log.info("update server complete");
												// we need to update the IsDeviceDirty flag of the audit in IndexDB
												auditService.updateIsDirty($s.auditId,$s.isDirty,function getIsDirtyUpdate(err, data){
													if (err) {
														log.error('error updateing isDirty flag: ' + err);
													}
													log.info("checkedSync: update IsDeviceDirty complete");
													// we need to call up the database version of SyncedOn because the update server proccess sets a more current SyncedOn on the server side
													auditService.getListByHerdId(function getF360ListByHerdId(err, data) {
														var auditlistItem = _.find(data,{AuditId: $s.auditId});
	
													//	log.info("checkedSync: updating last synced date with : ");
													//	log.info(auditlistItem);
	
														 //if the audit was deleted ,the record won't be in IndexedDB and doesn't need SyncedOn updated
														if(!_.isUndefined(auditlistItem)){ 
															auditService.updateLastSyncedDate($s.auditId,_.get(auditlistItem,'SyncedOn'),function getUpdateLastSyncDateData(err,data){
																if (err) {
																	log.error('error updating server with device data: ' + err);
																}
																
																log.info("checkedSync: last synced date update complete , sync end");
																$s.syncInProgress = false;
																
			
															});	 
														}else{
															log.info("checkedSync: audit was deleted . so no need to update last synced date. sync end ");
															$s.syncInProgress = false;
														}
		
													});
												});
												
												
	
											});
										}else{
										   // the device's SyncedOn Date is older than the server's copy of the same property and the device needs updating
											log.info("checkSync: server is up to date , need to check if device needs updating");
												if((_.isEqual(_.get(syncData,'ToUpdateDevice'),true)) || (_.isEqual(_.get(syncData,'ToUpdateDevice').toLowerCase(),"true"))){
													log.info("checkSync: device needs updating , setting device update flag true , sync end");
												
													 // if the device needs updating then we need to send the user back to the f360 dashboard to attempt a device sync after prompt
													$s.syncInProgress = false; 
													MSF.loadPage('Fertility360report');
												}else{
													log.info("checkSync: no server update needed , sync end");
													$s.syncInProgress = false; 
												}
											  
										}
									} else {
										log.info("checkedSync: no getSyncedStatus data returned , sync end");
										$s.syncInProgress = false;
										self.isSync = false;
									}

								} else {
									self.isSync = false;
								}	
							});
						});
				} else {
					self.isSync = false;
				}
			}
			/*
			window.onfocus = function() {
				$interval.cancel(checkSyncStatus);
				checkSyncStatus = $interval(function() {
					checkF360SyncStatus();
				}, f360Constant.checkF360SyncInterval);
			};

			window.onblur = function() {
				$interval.cancel(checkSyncStatus);
			};
*/

			$s.$on("$destroy", function() {
//				window.onblur = undefined;
//				window.onfocus = undefined;
			//	$interval.cancel($s.checkSyncStatusTimer);
				deregOnFarmChange();
			});
			
			deregOnFarmChange =	$s.$on('farm:changed',function(){
									MSF.loadPage('Fertility360report');
								});

			MSF.ready(function onMsfReady() {
				    $s.codeFile = _.cloneDeep(_.get(MSF,'lists.codeFile',[]));
					//local storage data 	
					var mySynchStateJSON = localStorage.getItem('MySynch-state');
					if(!_.isUndefined(mySynchStateJSON)){
						$s.mySynchState = JSON.parse(mySynchStateJSON);
	
						$s.activeFarm = _.get($s.mySynchState,'value.activeFarm',{});
					}
					$s.sliderWidth = $("#myinput").width();

					auditService.getActiveOrCurrentAuditVersion().then(function(apiVersion){
                          $s.auditApiVersion = apiVersion;
					});
	         
					loadCurrentHerd();
				    checkPermissions();
				    $s.loadReportData();
				
					
			
			});

		}
	]);
})();
